export const COLORS = {
  primary: '#2f6df6',
  accent: '#007bff',
  background: '#f5f7fb',
  card: '#ffffff',
  text: '#222',
  muted: '#666',
  danger: '#d00',
  success: '#28a745',
  border: '#e6e9ef',
};
